<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="config?.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ config.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1 ir-installationreceived_comment"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="surfaceType && surfaceType >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationroadsurface.surface-type' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ surfaceType | surfacetype }}</span>
      </p>
    </td>
  </tr>
</table>
